/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, catchError, map, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import {
    CashRegistersListAction,
    CashRegistersListActionType,
    fetchCashRegistersListErrorAction,
    fetchCashRegistersListSuccessAction,
} from 'data/actions/cashRegistersActions';
import { cashRegistersClient } from 'data/api/cashRegister/cashRegistersClient';
import { CashRegistersListRequestParams } from 'data/api/cashRegister/cashRegistersClient.typings';
import { CashRegistersListState } from 'data/reducers/cashRegisersReducer';

export const fetchCashRegistersListEpic: Epic<CashRegistersListAction> = (action$, state$) => {
    return action$.pipe(
        ofType(
            CashRegistersListActionType.OPEN_REGISTRY_CASH_REGISTERS_LIST_PAGE,
            CashRegistersListActionType.APPLY_PAGING,
            CashRegistersListActionType.APPLY_FILTERS,
        ),
        switchMap(() => {
            const queryParams = makeCashRegistersListRequestParamsFromState(state$.value.cashRegistersListReducer);
            return from(cashRegistersClient.listCashRegisters(queryParams)).pipe(
                map((list) => fetchCashRegistersListSuccessAction(list)),
                catchError((err: AxiosError) =>
                    of(
                        fetchCashRegistersListErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.cashRegistersListReqFailed')),
                        ),
                    ),
                ),
                takeUntil(action$.pipe(ofType(CashRegistersListActionType.EXIT_REGISTRY_CASH_REGISTERS_LIST_PAGE))),
            );
        }),
    );
};

function makeCashRegistersListRequestParamsFromState(state: CashRegistersListState): CashRegistersListRequestParams {
    return {
        limit: state.pageParams.limit,
        offset: state.pageParams.offset,
        ...state.filterParams,
    };
}
